exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox_type_question .v-messages {\r\n  min-height: unset;\n}\n.checkboxOptions .sb_checkbox {\r\n  margin-top: 8px;\n}\n.checkboxOptions .sb_checkbox .v-input__slot {\r\n  align-items: start;\n}\n#questionArea textarea {\r\n  font-size: 14px;\n}\r\n", ""]);

// exports
